import styles from "./CustomButton.module.scss";
import React, {CSSProperties} from "react";

interface ICustomButtonProps {
    text: string;
    iconPath?: string;
    type: "submit" | "button";
    typeStyle: "fill" | "outline";
    functionOnClick?: (e?: any) => void | Promise<void> | undefined;
    altIcon?: string;
    borderRadius: boolean;
    blueForOutline?: boolean;
    hoverToFillFromOutline?: boolean;
    disabled?: boolean;
    style?: CSSProperties;
}

const CustomButton: React.FC<ICustomButtonProps> = ({text, altIcon, iconPath, type, typeStyle, functionOnClick, borderRadius, blueForOutline, hoverToFillFromOutline, disabled, style}) => {
    return (
        <button
            style={style}
            type={type}
            className={`${styles.btn} ${borderRadius && styles.borderRadius} ${iconPath && styles.withIcon} ${styles[typeStyle]} ${typeStyle === "outline" && blueForOutline && styles.blue} ${hoverToFillFromOutline && styles.hoverToFillFromOutline}`}
            onClick={functionOnClick}
            disabled={disabled}
        >
            {text}
            {iconPath && altIcon && (
                <img src={iconPath} alt={altIcon}/>
            )}
        </button>
    )
}

export default CustomButton;